import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface CacheInfo {
  isInMemory: boolean;
  isLocal: boolean;
  environment: string;
  keys: { [keys: string]: string[] };
}

@Component({
  selector: 'app-cache',
  templateUrl: './cache.component.html',
  styleUrls: ['./cache.component.css']
})
export class CacheComponent implements OnInit {
  cacheInfo: CacheInfo | null = null;
  cacheMessage: string = "";

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.getCacheKeys();
  }

  get cacheKeyCount(): number {
    if (!this.cacheInfo) {
      return 0;
    }

    let count = 0;
    for (const key in this.cacheInfo.keys) {
      count += 1 + this.cacheInfo.keys[key].length;
    }

    return count;
  }

  get cacheKeyData(): string {
    if (this.cacheInfo) {
      return JSON.stringify(this.cacheInfo.keys, null, 2);
    }
    return "";
  }

  getCacheKeys(): void {
    this.cacheMessage = "Loading cache info...";
    this.http.get<CacheInfo>('Config/GetCacheKeys').subscribe({
      next: cacheInfo => {
        this.cacheInfo = cacheInfo;
        this.cacheMessage = "";
      },
      error: error => {
        this.cacheMessage = "An error occurred while getting the cache info.";
        console.error('Error getting cache keys', error);
      }
    });
  }

  resetCache(): void {
    this.cacheInfo = null;
    this.cacheMessage = "Resetting the cache...";
    this.http.post('Config/ResetCache', {}).subscribe({
      next: () => {
        this.getCacheKeys(); // update cache keys list after reset
      },
      error: error => {
        this.cacheMessage = "An error occurred while resetting the cache.";
        console.error('Error resetting the cache', error);
      }
    });
  }
}
